import { List, Title, Text, Stack, Space } from "@mantine/core";
import { LegalSection } from "@/components/legal-section";
import { createFileRoute } from "@tanstack/react-router";
import { Page } from "@/components/page";

export const Route = createFileRoute("/privacy-policy")({
  component: PrivacyPolicyRouteComponent,
});

function PrivacyPolicyRouteComponent() {
  return (
    <Page title="Privacy Policy">
      <Space h="2rem" />
      <Stack gap="4rem" maw="800" mx="auto" p="lg">
        <Title size="2.5rem">Privacy Policy</Title>
        <LegalSection title="1. Introduction">
          <Text>
            fapinstructor (fapchallenger) is committed to protecting your
            privacy. This Privacy Policy explains how we collect, use, disclose,
            and protect your personal information.
          </Text>
        </LegalSection>
        <LegalSection title="2. Information We Collect">
          <Text>We collect the following types of information:</Text>
          <List>
            <List.Item>
              Registration information: username, email, password
            </List.Item>
            <List.Item>User-generated content: games, scripts</List.Item>
            <List.Item>
              Usage data: interactions with the service, search queries
            </List.Item>
            <List.Item>
              Technical information: IP address, device type, browser
            </List.Item>
          </List>
        </LegalSection>
        <LegalSection title="3. How We Use Your Information">
          <Text>We use your information to:</Text>
          <List>
            <List.Item>Provide and improve our services</List.Item>
            <List.Item>Personalize your experience</List.Item>
            <List.Item>
              Process transactions and send account-related notifications
            </List.Item>
            <List.Item>Analyze service usage and conduct research</List.Item>
            <List.Item>
              Detect, prevent, and resolve technical or security issues
            </List.Item>
            <List.Item>Comply with legal obligations</List.Item>
          </List>
        </LegalSection>
        <LegalSection title="4. Sharing of Information">
          <Text>
            We do not sell your personal information. We may share your
            information in the following circumstances:
          </Text>
          <List>
            <List.Item>
              With service providers who help us operate fapinstructor
            </List.Item>
            <List.Item>
              To comply with legal obligations or respond to government requests
            </List.Item>
            <List.Item>
              To protect the rights, property, or safety of fapinstructor, our
              users, or the public
            </List.Item>
            <List.Item>With your consent or at your direction</List.Item>
          </List>
        </LegalSection>
        <LegalSection title="5. Data Security">
          <Text>
            We implement technical and organizational security measures to
            protect your information from unauthorized access, alteration,
            disclosure, or destruction. These measures include encryption,
            firewalls, and access controls for systems and files.
          </Text>
        </LegalSection>
        <LegalSection title="6. Your Rights and Choices">
          <Text>
            You have certain rights regarding your personal information,
            including:
          </Text>
          <List>
            <List.Item>Access and receive a copy of your information</List.Item>
            <List.Item>Rectify inaccurate information</List.Item>
            <List.Item>Request the deletion of your information</List.Item>
            <List.Item>
              Object to or restrict certain processing activities
            </List.Item>
            <List.Item>Withdraw your consent at any time</List.Item>
          </List>
          <Text>
            To exercise these rights, please contact us using the information
            provided at the end of this policy.
          </Text>
        </LegalSection>
        <LegalSection title="7. Data Retention">
          <Text>
            We retain your personal information for as long as necessary to
            provide our services and comply with our legal obligations. When we
            no longer have a legitimate business need to process your personal
            information, we will delete or anonymize it.
          </Text>
        </LegalSection>
        <LegalSection title="8. Changes to This Policy">
          <Text>
            We may update this Privacy Policy periodically. We will notify you
            of any material changes by posting the new policy on our website and
            updating the "last updated" date. We recommend that you review this
            policy regularly to stay informed about our privacy practices.
          </Text>
        </LegalSection>
        <LegalSection title="Contact Information ">
          <Text>
            If you have any questions about this privacy policy or our
            information-handling practices, please contact us at{" "}
            <a href="mailto:support@fapinstructor.com">
              support@fapinstructor.com
            </a>
          </Text>
        </LegalSection>
        <Text>
          For terms of use related questions, please visit{" "}
          <a href="/terms-of-service">Terms of Use</a>.
        </Text>
      </Stack>
      <Space h="xl" />
    </Page>
  );
}
